import { deleteEmptyObj } from '@/utils/utils'
const state = {
  page: 1,
  total: 0,
  limit: 10,
  unread: ''
}

const actions = {
  // 获取站内通知列表
  async mailGetData ({ commit, state }, playload) {
    const data = {
      title: playload,
      page: state.page,
      limit: state.limit
    }
    deleteEmptyObj(data)
    const res = await API.get(`/edu/zone/system/message/list`, data)
    commit('setState', {
      module: 'mail',
      key: 'total',
      value: res.data.total
    })
    return res
  },
  // 获取未读消息数量
  async getUnreadMessage ({ commit }) {
    const { status, data } = await API.get('/edu/zone/system/message/unread/num')
    if (status < 400) {
      commit('SET_UNREAD', data.un_read_num)
    }
  },
  // 设置已读消息
  async setReadMessage ({ commit }, playload) {
    await API.get(`/edu/zone/system/message/read/${playload}`)
  },
  // 设置消息提醒已读消息
  async setInviteReadMessage ({ commit }, id) {
    await API.post(`/edu/zone/invite/message/${id}/read`)
  },
  // 获取私有资源下载链接
  async download ({ state }, data) {
    const res = await API.post(`/edu/zone/system/message/resource/url`, { resource_path: data })
    return res
  },
  // 获取站内通知列表
  async getMessages ({ commit, state }) {
    const res = await API.get(`/edu/zone/invite/teacher/messages?page=${state.page}&limit=${state.limit}`)
    commit('setState', {
      module: 'mail',
      key: 'total',
      value: res.data.total
    })
    return res
  },
  // 全部已读
  async mailAllRead ({ commit, state }) {
    const res = await API.post(`/edu/zone/invite/message/all/read`)
    return res
  },
  // 学生获取邀请加入班级消息
  async getInviteMessage ({ commit, state }) {
    const res = await API.get(`/edu/zone/invite/student/message/next`)
    return res
  },
  // 学生拒绝邀请加入班级消息
  async refuseInviteMessage ({ commit, state }, id) {
    const res = await API.post(`/edu/zone/invite/student/message/${id}/refuse`)
    return res
  },
  // 学生同意邀请加入班级消息
  async agreeInviteMessage ({ commit, state }, id) {
    const res = await API.post(`/edu/zone/invite/student/message/${id}/accept`)
    return res
  }
}

const mutations = {
  SET_UNREAD (state, value) {
    state.unread = value
  },
  mailInit (state) {
    state.page = 1
    state.total = 0
    state.limit = 10
  }
}

export default {
  state,
  actions,
  mutations
}
